import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import "@/assets/stytles/flex.css"
import '@/styles/index.scss'

import '@/icons' // icon
import { getDate } from '@/utils/util'

Vue.use(ElementUI, { size: 'medium', zIndex: 3000 });

import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)
// Vue.use(Loading.directive)
import permission from "./directives/promise";
Vue.directive('permission', permission)

Vue.config.productionTip = false

// 分页组件
import Pagination from "@/components/Pagination";


// 全局组件挂载
Vue.component('Pagination', Pagination)


Vue.prototype.getDate = getDate

Vue.prototype.serveImgUrl = process.env.VUE_APP_BASE_API

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
